import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { config } from "../../../../environments/config";
import { Cuenta, EstadoCuenta } from "../../_model/cuentas/cuenta";
import { Socios } from 'app/main/_model';
import { ConvAhorro, ConvAhorroTabla } from 'app/main/_model/conv-ahorro/ahorro';

@Injectable({
    providedIn: 'root'
})
export class CuentasService {


    constructor(private http: HttpClient) {
    }

    getProducts(token) {
        const params = new HttpParams()
            .set('token', token);
        return this.http.post<any>(`${config.apiUrl}/socio/cuentas`, params)
            .toPromise()
            .then(res => <Cuenta[]>res.data)
            .then(data => {
                return data;
            });
    }
    cuentaAcreditarTransferecia(token, cuenta, producto) {
        const params = new HttpParams()
            .set('token', token)
            .set('cuentasocio', cuenta)
            .set('productosocio', producto);
        return this.http.post<any>(`${config.apiUrl}/socio/cuenta/transferir`, params)
            .toPromise()
            .then(res => <Socios>res.data)
            .then(data => {
                return data;
            });
    }
    filterCuentas(token, cuenta, producto) {
        const params = new HttpParams()
            .set('token', token)
            .set('cuentasocio', cuenta)
            .set('productosocio', producto);
        return this.http.post<any>(`${config.apiUrl}/socio/cuenta`, params)
            .toPromise()
            .then(res => <Cuenta[]>res.data)
            .then(data => {
                return data;
            });
    }

    filterCuentasProducto(token, producto) {
        const params = new HttpParams()
            .set('token', token)
            .set('producto', producto);
        return this.http.post<any>(`${config.apiUrl}/socio/cuenta/filterproducto`, params)
            .toPromise()
            .then(res => <Cuenta[]>res.data)
            .then(data => {
                return data;
            });
    }

    estadoCuenta(token, desde, hasta, producto, cuenta) {
        const params = new HttpParams()
            .set('token', token)
            .set('desde', desde)
            .set('hasta', hasta)
            .set('producto', producto)
            .set('cuenta', cuenta);
        return this.http.post<any>(`${config.apiUrl}/socio/cuentas/detalle`, params)
            .toPromise()
            .then(res => <EstadoCuenta[]>res.data)
            .then(data => {
                return data;
            });
    }

    filterSocioAutorizaciones(token) {
        const params = new HttpParams()
            .set('token', token)
        // .set('producto', producto);
        return this.http.post<any>(`${config.apiUrl}/socio/autorizaciones`, params)
            .toPromise()
            .then(res => <ConvAhorro[]>res.data)
            .then(data => {
                return data;
            });
    }

    getAutorizacion(token, numAutorizacion) {
        const params = new HttpParams()
            .set('token', token)
            .set('autorizacion', numAutorizacion);
        return this.http.post<any>(`${config.apiUrl}/socio/autorizaciones/get`, params)
            .toPromise()
            .then(res => <ConvAhorro>res.data)
            .then(data => {
                return data;
            });
    }

    filterAutorizacionesCuentas(token, prod1, cuenta1, prod2, cuenta2) {
        const params = new HttpParams()
            .set('token', token)
            .set('producto1', prod1)
            .set('cuenta1', cuenta1)
            .set('producto2', prod2)
            .set('cuenta2', cuenta2);
        return this.http.post<any>(`${config.apiUrl}/socio/autorizaciones/get-cuentas`, params)
            .toPromise()
            .then(res => <ConvAhorro[]>res.data)
            .then(data => {
                return data;
            });
    }

    crearAutorizacion(token, prod1, cuenta1, prod2, cuenta2, fechaI, fechaV, valor, cuotas, estado) {
        const params = new HttpParams()
            .set('token', token)
            .set('producto1', prod1)
            .set('cuenta1', cuenta1)
            .set('producto2', prod2)
            .set('cuenta2', cuenta2)
            .set('fechaI', fechaI)
            .set('fechaV', fechaV)
            .set('valor', valor)
            .set('cuotas', cuotas)
            .set('estado', estado);
        return this.http.post<any>(`${config.apiUrl}/socio/autorizaciones/create`, params)
            .toPromise()
            .then(res => <ConvAhorro>res.data)
            .then(data => {
                return data;
            });
    }

    actualizarStsAutorizacion(token, numAutorizacion) {
        const params = new HttpParams()
            .set('token', token)
            .set('autorizacion', numAutorizacion);
        return this.http.post<any>(`${config.apiUrl}/socio/autorizaciones/update`, params)
            .toPromise()
            .then(res => <ConvAhorro>res.data)
            .then(data => {
                return data;
            });
    }

    crearAutorizacionTabla(token, body: ConvAhorroTabla[]) {
        return this.http.post<any>(`${config.apiUrl}/socio/autorizaciones/create-table?token=` + token, body)
            .toPromise()
            .then(res => <ConvAhorroTabla[]>res.data)
            .then(data => {
                return data;
            });
    }

    getPDFAhorro(token, num) {
        const headers = new HttpHeaders({ 'Content-Type': 'application/pdf' });
        return this.http.get(`${config.apiUrl}/socio/autorizaciones/pdf-ahorro?token=`+token+`&autorizacion=`+num, { headers, responseType: 'arraybuffer' });
    }

    // eliminarAutorizacion(token, numAutorizacion) {
    //     const params = new HttpParams()
    //         .set('token', token)
    //         .set('autorizacion', numAutorizacion);
    //     return this.http.post<any>(`${config.apiUrl}/socio/autorizaciones/delete`, params)
    //         .toPromise()
    //         .then(res => <ConvAhorro>res.data)
    //         .then(data => {
    //             return data;
    //         });
    // }
}
